// import Vuex from 'vuex';
// import Vue from 'vue';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import Pagination from '../Pagination/index';

// Vue.use(Vuex);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        // Pagination: new Vuex.Store({
        //     Pagination
        // })
        Pagination
    }
};
